import axios from 'axios';

/**
 * For SEO reason we want to redirect the user to the
 * service content page if it exist.
 */
export class FrontSearchBijles {

  constructor() {
    this.$bijlesSearchForms = $('.front-search__form[name="HWBSearch"], .front-search__form[name="BLSearch"], .front-search__form[name="ElmSearch"]');


    // intercept the submit action
    this.$bijlesSearchForms.on('submit', e => this.onSubmitSearchForm(e));
  }

  /**
   * When the user submits the form check if there is an content page like
   * http://lyc.wp.dev.techniek-team.nl/huiswerkbegeleiding/leiden/
   *
   * if there is no content page redirect to the search page
   * http://lyc.wp.dev.techniek-team.nl/huiswerkbegeleiding/aanmelden/?city=parijs
   *
   * works for Bijles, Huiswerkbegleiding and Basisschoolbegleiding
   */
  async onSubmitSearchForm(e) {
    const $form = $(e.currentTarget);

    console.log('hi');

    $form.find('[type="submit"]')
      .attr('disabled', 'true')
      .html('<i class="fa fa-spinner fa-spin"></i>');

    if ($form.attr('name') !== 'ElmSearch') {
      e.preventDefault(); // prevent form from submitting

      const formAction = $form.attr('action');

      const baseUrl = formAction.replace('/aanmelden/', '');

      console.log('hi');


      const searchTerm = $form
        .serializeArray()[0]
        .value;

      if (!searchTerm || searchTerm === '') {
        this.redirectTo(formAction);
        return;
      }

      // cast the city to lowercase and remove the spaces
      const contentCity = searchTerm.toLowerCase().replace(/\s+/g, '-');
      const contentPage = `${baseUrl}/${contentCity}`;
      const searchPage = `${formAction}?city=${searchTerm}`;

      try {
        // Check if the content page exist.
        await axios.get(contentPage);
        // Redirect to the content page if it exists.
        this.redirectTo(encodeURI(contentPage));
      } catch (e) {
        this.redirectTo(encodeURI(searchPage));
      }
    }
  }

  /**
   * Redirect the user
   * note: put in separate function so we can test it
   */
  /* istanbul ignore next */
  redirectTo(url) {
    window.location = url;
  }
}
